import Entity from "@/services/westore/entities/entity";

export class IntegrationRedirect extends Entity {
  static handle(marketPlace, query) {
    return super.get(`/integrations/${marketPlace}/callback${query}`);
  }
  static generateUrl(storeUrl) {
    return super.create(`/integrations/generate-callback-url`, storeUrl);
  }
}
